import React from 'react';
import './CatLoader.css';

// Искры — монохромные глифы (не эмодзи), цвет задаётся в CSS.
const SPARK_CHARS = ['✦', '✧', '✦', '✧', '✦', '✧'];

// Кошачья лапка (SVG вместо эмодзи 🐾) — цвет через currentColor.
const PawTrail = () => (
  <svg viewBox="0 0 32 30" xmlns="http://www.w3.org/2000/svg" className="cg-paw-svg">
    <ellipse cx="16" cy="21" rx="8" ry="6.5" fill="currentColor" />
    <circle cx="6.5" cy="13" r="3" fill="currentColor" />
    <circle cx="12.5" cy="8.5" r="3.1" fill="currentColor" />
    <circle cx="19.5" cy="8.5" r="3.1" fill="currentColor" />
    <circle cx="25.5" cy="13" r="3" fill="currentColor" />
  </svg>
);

// Компактная inline-версия для таблиц и блоков (не на весь экран)
export function CatLoaderInline() {
  return (
    <div className="cg-loader-inline">
      <div className="cg-loader-inline__runner">
        <div className="cg-loader-inline__dir">
          <video
            src="/cat-girl-run.webm"
            className="cg-loader-inline__cat"
            autoPlay
            loop
            muted
            playsInline
            disableRemotePlayback
          />
          <span className="cg-loader-inline__shadow" />
        </div>
      </div>
      <div className="cg-loader-inline__paws">
        {[0, 1, 2, 3].map(i => (
          <span key={i} className="cg-loader-inline__paw"><PawTrail /></span>
        ))}
      </div>
      <p className="cg-loader-inline__text">
        считаю<span className="cg-loader-inline__dots">...</span>
      </p>
    </div>
  );
}

// Полноэкранная версия (auth loading) — Мурка прыгает по треку
export default function CatLoader() {
  return (
    <div className="cg-loader-screen">
      <div className="cg-loader-stage">
        <div className="cg-loader-runner">
          <div className="cg-loader-dir">
            <video
              src="/cat-girl-run.webm"
              className="cg-loader-cat"
              autoPlay
              loop
              muted
              playsInline
              disableRemotePlayback
            />
            <span className="cg-loader-shadow" />
          </div>
        </div>

        <div className="cg-loader-paws">
          {[0, 1, 2, 3, 4].map(i => (
            <span key={i} className="cg-loader-paw"><PawTrail /></span>
          ))}
        </div>

        <div className="cg-loader-sparks" aria-hidden="true">
          {SPARK_CHARS.map((ch, i) => (
            <span key={i} className="cg-loader-spark">{ch}</span>
          ))}
        </div>
      </div>

      <p className="cg-loader-text">
        мяу<span className="cg-loader-ellipsis">...</span>
      </p>
      <p className="cg-loader-sub">Мурка считает</p>
    </div>
  );
}
